export default "__VITE_ASSET__RFq4tRLC__"